import React from "react";
import { makeStyles } from "@mui/styles";
import { Paper, Divider } from "@mui/material";
import ItemFileUploaderCard from "~business/Cards/ItemFileUploaderCard";
import { Button } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {
  setTautos30FileName,
  setExtradFileName,
  setGruposFileName,
  setSubmitting,
  moveArchivosInfoautoFinalDest,
  ArchivoSeleccionado,
  MoveArchivosInfoautoData,
  SubidaArchivosInfoautoState,
} from "./actions";
import { queueMessage } from "~shared/snackbarsProvider/actions";
import { useSelector, useDispatch } from "react-redux";
import environment from "~libs/environment";
import SuccessDialog from "~components/shared/SuccessDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
    backgroundColor: theme.colours.white,
  },
  tableContainer: {
    width: "100%",
    backgroundColor: theme.colours.white,
    overflow: "auto",
    minHeight: 500,
  },
}));

type ArchivoInfoauto = "tautos30" | "extrad" | "grupos";

const filenames = {
  tautos30: setTautos30FileName,
  extrad: setExtradFileName,
  grupos: setGruposFileName,
};

/** Lo que emite la caja de subida en onAdded y onRemoved. */
interface FileUploaderEvent {
  target: { value: string };
}

const useReduxSelector = () =>
  useSelector<any, SubidaArchivosInfoautoState>((state) => ({
    ...state.subidaArchivosInfoautoReducer,
  }));

const SubidaArchivosInfoauto: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    tautos30FileNameSelected,
    extradFileNameSelected,
    gruposFileNameSelected,
    archivosSubidos,
  } = useReduxSelector();

  const handleFileAdded = (event: unknown, filename: ArchivoInfoauto) => {
    const action = filenames[filename];
    const value = `temp/${(event as FileUploaderEvent).target.value}`;
    const seleccionado: ArchivoSeleccionado = {
      value: value,
      valid: true,
    };
    dispatch(action(seleccionado));
  };

  const handleRemoved = (event: unknown, filename: ArchivoInfoauto) => {
    const action = filenames[filename];
    const seleccionado: ArchivoSeleccionado = {
      value: null,
      valid: false,
    };
    dispatch(action(seleccionado));
  };

  const handleSubirArchivos = () => {
    dispatch(setSubmitting(true));
    handleSubmitForm();
  };

  const handleSubmitForm = async () => {
    if (!tautos30FileNameSelected?.value) {
      dispatch(queueMessage("Debe seleccionar el archivo tautos30.dbf"));
      return;
    }

    if (!extradFileNameSelected?.value) {
      dispatch(queueMessage("Debe seleccionar el archivo extrad.dbf"));
      return;
    }

    if (!gruposFileNameSelected?.value) {
      dispatch(queueMessage("Debe seleccionar el archivo grupos.dbf"));
      return;
    }

    let data: MoveArchivosInfoautoData = {
      sourceBucket: environment.bucketName,
      tautos30Filename: tautos30FileNameSelected.value,
      extradFilename: extradFileNameSelected.value,
      gruposFilename: gruposFileNameSelected.value,
      destBucket: environment.vehiclesBucketName,
    };
    dispatch(moveArchivosInfoautoFinalDest(data) as any);
  };

  return (
    <div className={classes.root}>
      <SuccessDialog
        message="Archivos subidos correctamente"
        openDialog={archivosSubidos}
      />

      <Paper className={classes.root}>
        <div className={classes.tableContainer}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          ></div>
          <Divider></Divider>

          <ItemFileUploaderCard
            label="Subir archivo tautos30.dbf"
            onAdded={(event) => handleFileAdded(event, "tautos30")}
            onRemoved={(event) => handleRemoved(event, "tautos30")}
            acceptImage={false}
            acceptPdf={false}
          />
          <ItemFileUploaderCard
            label="Subir archivo extrad.dbf"
            onAdded={(event) => handleFileAdded(event, "extrad")}
            onRemoved={(event) => handleRemoved(event, "extrad")}
            acceptImage={false}
            acceptPdf={false}
          />
          <ItemFileUploaderCard
            label="Subir archivo grupos.dbf"
            onAdded={(event) => handleFileAdded(event, "grupos")}
            onRemoved={(event) => handleRemoved(event, "grupos")}
            acceptImage={false}
            acceptPdf={false}
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handleSubirArchivos}
          >
            Subir Archivos
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default SubidaArchivosInfoauto;
